import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../redux/reducers/root";
import { Booking } from "../../../../redux/types";
import { getOfficeDescription, getOfficeType } from "../../../../utils/get-office-details";

interface Props {
  booking: Booking;
}

const renderRow = (col1: string | ReactNode, col2: string | ReactNode) => {
  return (
    <div className="flex mb-2">
      <div className="flex-1">{col1}</div>
      <div className="flex-1">{col2}</div>
    </div>
  );
};
const bookingItem: React.FC<Props> = ({ booking }) => {
  const offices = useSelector((state: State) => state.offices);
  const office = offices.data.find((i) => i.id === booking.timeslot.officeId)!;

  return (
    <div>
      {renderRow("نام و نام خانوادگی", `${booking.user.firstName} ${booking.user.lastName}`)}
      {renderRow("نوع رزرو", `${getOfficeType(office)}`)}
      {renderRow("محل", `${getOfficeDescription(office)}`)}
      {renderRow(
        "وضعیت پرداخت",
        <span className={booking.paid ? "text-pkc-primary" : "text-pkc-red"}>
          {booking.paid ? "انجام شده" : "انجام نشده"}
        </span>
      )}
      {renderRow("خدمت انتخابی", `${booking.practiceName}`)}
    </div>
  );
};

export default bookingItem;
